// Tests if target is an SVGGraphicsElement
var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
// Checks to see if element is hidden (has no display)
var isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
// Checks if an object is an Element
var isElement = function (obj) {
    var _a, _b;
    var scope = (_b = (_a = obj) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function (target) {
    // tierik - modified this function to avoid error TS7029.
    // the switch statement just makes it overly complicated anyway
    if (target.tagName === 'INPUT' && target.type !== 'image') {
        return false;
    }
    return true;
    // switch (target.tagName) {
    //   case 'INPUT':
    //     if ((target as HTMLInputElement).type !== 'image') {
    //       break;
    //     }
    //   case 'VIDEO':
    //   case 'AUDIO':
    //   case 'EMBED':
    //   case 'OBJECT':
    //   case 'CANVAS':
    //   case 'IFRAME':
    //   case 'IMG':
    //     return true;
    // }
    // return false;
};
export { isSVG, isHidden, isElement, isReplacedElement };
